<div class="ehe-migration-modal-wrapper" id="ehe-modal">
	<div class="ehe-modal">
		<div class="title-top-border"></div>
		<div class="ehe-modal-header text-18">{{ title }}</div>
		<div class="ehe-modal-body">
			<mat-dialog-content>
				<ng-content></ng-content>
				<p *ngIf="content" [innerHTML]="content"></p>
			</mat-dialog-content>
		</div>
		<div class="ehe-modal-footer">
			<div class="d-flex justify-content-center">
				<button
					*ngIf="migrationStatus === 'Initiated'"
					class="button button-medium"
					appGoogleAnalytics
					mat-button
					matDialogClose
					(click)="submit()"
					[eventData]="{
						eventCategory: 'Button',
						eventAction: 'Create Account Flow - Migration',
						eventLabel: 'Migration - Navigate to Password'
					}"
					appEheAnalytics
					[data]="{
						pageUrl: '/registration',
						redirectedTo: '/migration/password',
						componentName: 'migration-notification-modal',
						id: 'Migration Notification Modal',
						placement: 'Migration Notification Modal'
					}">
					{{ button1 }}
				</button>
				<button
					*ngIf="migrationStatus === 'Failed'"
					class="button button-medium"
					appGoogleAnalytics
					mat-button
					matDialogClose
					(click)="submit()"
					[eventData]="{
						eventCategory: 'Button',
						eventAction: 'Create Account Flow - Migration',
						eventLabel: 'Migration - Navigate to Email'
					}"
					appEheAnalytics
					[data]="{
						pageUrl: '/registration',
						redirectedTo: '/migration/email',
						componentName: 'migration-notification-modal',
						id: 'Migration Notification Modal',
						placement: 'Migration Notification Modal'
					}">
					{{ button1 }}
				</button>
			</div>
		</div>
	</div>
</div>
